import { createSlice, combineReducers } from '@reduxjs/toolkit'
import {
  view,
  viewApplication,
  viewClient,
  viewCollateral,
  viewLoan,
  destroyReporingViewData,
} from './reporting.actions'

type InitialState<T = unknown> = {
  status: 'idle' | 'loading' | 'loaded' | 'failed'
  data: T | null
  error: string | null
}

const reportingInitialState: InitialState<unknown> = {
  status: 'loading',
  data: null,
  error: null,
}

const reportingSlice = createSlice({
  name: 'reporting_data',
  initialState: reportingInitialState,
  reducers: {},
  extraReducers: {
    [view.pending.toString()]: (state) => {
      state.status = 'loading'
    },
    [view.fulfilled.toString()]: (state, action) => {
      state.status = 'loaded'
      state.data = action.payload
    },
    [view.rejected.toString()]: (state, action) => {
      state.status = 'failed'
      state.data = null
      state.error = action.payload
    },
    [destroyReporingViewData.toString()]: (state) => {
      return {
        ...state,
        data: null,
      }
    },
  },
})

const viewClientInitialState: InitialState<null> = {
  status: 'loading',
  data: null,
  error: null,
}

const viewClientSlice = createSlice({
  name: 'view_client',
  initialState: viewClientInitialState,
  reducers: {},
  extraReducers: {
    [viewClient.pending.toString()]: (state) => {
      state.status = 'loading'
    },
    [viewClient.fulfilled.toString()]: (state, action) => {
      state.status = 'loaded'
      state.data = action.payload
    },
    [viewClient.rejected.toString()]: (state, action) => {
      state.status = 'failed'
      state.data = null
      state.error = action.payload
    },
  },
})

const viewLoanInitialState: InitialState<null> = {
  status: 'loading',
  data: null,
  error: null,
}

const viewLoanSlice = createSlice({
  name: 'view_loan',
  initialState: viewLoanInitialState,
  reducers: {},
  extraReducers: {
    [viewLoan.pending.toString()]: (state) => {
      state.status = 'loading'
    },
    [viewLoan.fulfilled.toString()]: (state, action) => {
      state.status = 'loaded'
      state.data = action.payload
    },
    [viewLoan.rejected.toString()]: (state, action) => {
      state.status = 'failed'
      state.data = null
      state.error = action.payload
    },
  },
})

const viewApplicationInitialState: InitialState<null> = {
  status: 'loading',
  data: null,
  error: null,
}

const viewApplicationSlice = createSlice({
  name: 'view_application',
  initialState: viewApplicationInitialState,
  reducers: {},
  extraReducers: {
    [viewApplication.pending.toString()]: (state) => {
      state.status = 'loading'
    },
    [viewApplication.fulfilled.toString()]: (state, action) => {
      state.status = 'loaded'
      state.data = action.payload
    },
    [viewApplication.rejected.toString()]: (state, action) => {
      state.status = 'failed'
      state.data = null
      state.error = action.payload
    },
  },
})

const viewCollateralInitialState: InitialState<null> = {
  status: 'loading',
  data: null,
  error: null,
}

const viewCollateralSlice = createSlice({
  name: 'view_collateral',
  initialState: viewCollateralInitialState,
  reducers: {},
  extraReducers: {
    [viewCollateral.pending.toString()]: (state) => {
      state.status = 'loading'
    },
    [viewCollateral.fulfilled.toString()]: (state, action) => {
      state.status = 'loaded'
      state.data = action.payload
    },
    [viewCollateral.rejected.toString()]: (state, action) => {
      state.status = 'failed'
      state.error = action.payload
      state.data = null
    },
  },
})

export const reportingReducer = combineReducers({
  ['DetailsReports-Client']: viewClientSlice.reducer,
  ['DetailsReports-Loan']: viewLoanSlice.reducer,
  ['DetailsReports-Application']: viewApplicationSlice.reducer,
  ['DetailsReports-Collateral']: viewCollateralSlice.reducer,
  reportingData: reportingSlice.reducer,
})
